import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { BookmarkModel } from '../bookmarks/models/bookmark.model';
import { exploreMenu } from './data/explore-menu';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var webOnlyTags = ['web platform', '!obsolete'];
var ExploreService = /** @class */ (function () {
    function ExploreService(http) {
        this.http = http;
    }
    ExploreService.prototype.search = function (keyword, tags, lang) {
        var _this = this;
        if (keyword === void 0) { keyword = ''; }
        if (tags === void 0) { tags = []; }
        if (lang === void 0) { lang = 'en'; }
        // seperate keywords
        var queryKeywords = keyword.split(/[ ]+/)
            .join('+');
        // quote seperate tags
        var queryTags = webOnlyTags.concat(tags)
            .map(function (tag) { return "\"" + tag + "\""; })
            .join('+');
        return this.http.get("/search?k=" + queryKeywords + "&t=" + queryTags + "&ol=" + lang)
            .pipe(map(function (result) { return _this.resultsToBookmarks(result); }));
    };
    ExploreService.prototype.getAnatomyCategory = function (query, category, lang) {
        return this.search(query, [category], lang);
    };
    // get condition model search result
    ExploreService.prototype.getConditionModel = function (id) {
        var _this = this;
        var dbID = this.toDatabaseContentId(id);
        return this.http.get("/search/conditions?q=" + dbID)
            .pipe(map(function (result) { return _this.resultsToBookmarks(result); }), map(function (bookmarks) { return bookmarks[0]; }));
    };
    ExploreService.prototype.resultsToBookmarks = function (result) {
        var _this = this;
        result.forEach(function (bookmark) {
            bookmark.id = _this.toAppContentId(bookmark.id);
            bookmark.tour = bookmark.tags.indexOf('tour') >= 0;
        });
        return plainToClass(BookmarkModel, result);
    };
    // Bookmark category is currently embedded as a tag inside a string array, making it
    // difficult to get to. This function checks for matches in the tags against the 
    // menu system and attempts to find match. 
    ExploreService.prototype.getBookmarkCategory = function (bookmark) {
        if (!bookmark.tags) {
            return null;
        }
        var tags = exploreMenu.categories.map(function (category) { return category.tag.toLocaleLowerCase(); });
        return bookmark.tags.find(function (tag) { return tags.includes(tag.toLocaleLowerCase()); });
    };
    ExploreService.prototype.getStoryCategory = function (story) {
        if (!story.tags) {
            return null;
        }
        var tags = exploreMenu.categories.map(function (category) { return category.tag.toLocaleLowerCase(); });
        return story.tags.find(function (tag) { return tags.includes(tag.toLocaleLowerCase()); });
    };
    // Normalizes id to app formatted id (i.e., production/maleAdult/flu)
    ExploreService.prototype.toAppContentId = function (id) {
        return id.replace('Condition.content.', '')
            .replace('.json', '')
            .split('.')
            .join('/');
    };
    // Normalizes id to DB format (i.e., Condition.content.production.maleAdult.flu.json)
    ExploreService.prototype.toDatabaseContentId = function (id) {
        if (!id.match('Condition.content')) {
            var normalizedId = id.replace('.json', '').split('/').join('.');
            return "Condition.content." + normalizedId + ".json";
        }
        else {
            return id;
        }
    };
    ExploreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExploreService_Factory() { return new ExploreService(i0.ɵɵinject(i1.HttpClient)); }, token: ExploreService, providedIn: "root" });
    return ExploreService;
}());
export { ExploreService };
